import { IconProps } from "@mui/material"
import * as React from "react"

export const InboxIcon = (props: IconProps) => {
  const { color = "currentColor" } = props

  return (
    <svg width="48" height="41" viewBox="0 0 48 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M46.331 25.2425L36.6167 16.4993H11.3832L1.66891 25.2425L0.332016 23.7575L10.6165 14.5007H37.3842L47.6687 23.7575L46.331 25.2425Z"
        fill={color}
      />
      <path
        d="M45 41H3C1.34626 41 0 39.6537 0 38V23.5006H15.9994V24.5C15.9994 26.9806 18.0187 29 20.4994 29H27.4987C29.9794 29 31.9987 26.9806 31.9987 24.5V23.5006H47.9981V38C48 39.6537 46.6537 41 45 41H45ZM2.00064 25.4994V38C2.00064 38.5512 2.44876 38.9994 3 38.9994H45C45.5512 38.9994 45.9994 38.5512 45.9994 38V25.4994H33.9245C33.4407 28.6119 30.7445 31.0006 27.5006 31.0006H20.4994C17.2556 31.0006 14.5574 28.6119 14.0755 25.5013L2.00064 25.4994Z"
        fill={color}
      />
      <path d="M14.3438 0.963135L17.8445 6.46249L16.157 7.53688L12.6563 2.03752L14.3438 0.963135Z" fill={color} />
      <path d="M34.1568 0.963135L35.8443 2.03752L32.3456 7.53688L30.6581 6.46249L34.1568 0.963135Z" fill={color} />
      <path d="M23.0007 -0.000671387H25.0013V6.49997H23.0007V-0.000671387Z" fill={color} />
    </svg>
  )
}
